import React from "react";

const WHATSAPP_URL = "https://wa.me/+79667244229";

export const DuneMainPage: React.FC = () => {
    return (
        <div className="w-full bg-white">
            <div className="mx-auto w-full max-w-[980px] px-4 pb-10 pt-6 sm:px-6 sm:pb-14 sm:pt-8">
                {/* Основная карточка (в стиле ваших блоков) */}
                <div className="rounded-2xl border border-slate-200/70 bg-white px-4 py-5 shadow-sm sm:px-6 sm:py-7">
                    <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-medium text-slate-700">
                        <span className="h-1.5 w-1.5 rounded-full bg-slate-400" />
                        Официальное сообщение
                    </div>

                    <h1 className="mt-4 text-[22px] font-semibold leading-snug text-slate-900 sm:text-3xl">
                        Завершение сотрудничества с агентством Dune
                    </h1>

                    <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-slate-700">
                        <p>Агентством Dune принято решение завершить совместную работу с HusamHelper.</p>
                        <p>
                            HusamHelper искренне благодарит команду Dune за плодотворное сотрудничество,
                            доверие и совместные результаты.
                        </p>
                    </div>

                    {/* Разделы */}
                    <div className="mt-6 grid gap-3 sm:grid-cols-2">
                        <div className="rounded-2xl border border-slate-200/70 bg-white p-4 sm:p-5">
                            <div className="text-sm font-semibold text-slate-900">Что будет дальше</div>

                            <ul className="mt-3 space-y-2 text-[14px] leading-relaxed text-slate-700">
                                <li className="flex gap-2">
                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-slate-400" />
                                    <span>HusamHelper продолжает работу в обычном режиме.</span>
                                </li>
                                <li className="flex gap-2">
                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-slate-400" />
                                    <span>Мы усиливаем продукт и расширяем партнёрскую сеть.</span>
                                </li>
                                <li className="flex gap-2">
                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-slate-400" />
                                    <span>
                    Если вы клиент/риэлтор Dune, мы подскажем, как комфортно продолжить
                    работу с HusamHelper.
                  </span>
                                </li>
                            </ul>
                        </div>

                        <div className="rounded-2xl border border-slate-200/70 bg-slate-50 p-4 sm:p-5">
                            <div className="text-sm font-semibold text-slate-900">Важно</div>
                            <p className="mt-3 text-[14px] leading-relaxed text-slate-700">
                                Мы сохраняем уважение к команде Dune и благодарим всех, кто был рядом.
                                Просим избегать домыслов и некорректных интерпретаций.
                            </p>

                            {/* Единственная ссылка */}
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noreferrer"
                                className="mt-5 inline-flex w-full items-center justify-center rounded-2xl bg-[#25D366] px-4 py-3 text-sm font-semibold text-white shadow-sm transition hover:brightness-95 active:brightness-90"
                            >
                                Продолжить работу с нами в WhatsApp
                            </a>

                            <div className="mt-3 text-center text-xs text-slate-500">
                                WhatsApp: +7 (966) 724-42-29
                            </div>
                        </div>
                    </div>
                </div>

                {/* маленький нижний отступ/«воздух», как в ваших страницах */}
                <div className="mt-6 rounded-2xl border border-slate-200/70 bg-white p-4 text-center text-xs text-slate-500 shadow-sm">
                    HusamHelper
                </div>
            </div>
        </div>
    );
};

export default DuneMainPage;
